import { defineStore } from 'pinia'

type State = {
  authenticated: -1 | 0 | 1, // 0 = false, 1 = true, -1 = unknown
}

export const useAuthStore = defineStore('Auth', {
  state: (): State => ({
    authenticated: -1,
  }),
  actions: {
    setAuthenticated (authenticated: -1 | 0 | 1) {
      this.authenticated = authenticated
    },
  },
})
